import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppSettings } from "../app-settings";

import { Storage } from "@ionic/storage";
import { AccountService } from "./account.service";
@Injectable({
  providedIn: "root",
})
export class TransactionsService {
  constructor(
    private http: HttpClient,
    private storage: Storage,
    private accountService: AccountService
  ) {}
  public getConstraints(mailingList, transactionType) {
    return new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };
        const params = `?mailing_list=${mailingList}&transaction_type=${transactionType}`;
        this.http
          .get(
            AppSettings.SERVER_URL + "transactions/constraints/" + params,
            options
          )
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
  }
  public details(transactionId) {
    let promise = new Promise((resolve, reject) => {
      this.accountService
        .getSessionKey()
        .then((key) => {
          const headers = new HttpHeaders({
            Authorization: "Token " + key,
            accept: "application/json",
          });

          const options = { headers: headers };

          this.http
            .get(
              AppSettings.SERVER_URL + "transactions/" + transactionId + "/",
              options
            )
            .toPromise()
            .then((response) => {
              resolve(response);
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error));
    });

    return promise;
  }

  public list(page = 1, filters = {}) {
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        let params = new HttpParams().append("page", page.toString());

        if (!!filters) {
          Object.keys(filters).forEach((key) => {
            params = params.append(key, filters[key]);
          });
        }

        const options = { params: params, headers: headers };

        this.http
          .get(AppSettings.SERVER_URL + "transactions/", options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });

    return promise;
  }

  public history(page = 1, filters = {}) {
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        let params = new HttpParams().append("page", page.toString());

        if (!!filters) {
          Object.keys(filters).forEach((key) => {
            params = params.append(key, filters[key]);
          });
        }

        const options = { params: params, headers: headers };

        this.http
          .get(AppSettings.SERVER_URL + "transactions/mine/", options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });

    return promise;
  }

  public create(pendingOffers: object[]) {
    let t = this;

    let promise = new Promise(async (resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        t.http
          .post(
            AppSettings.SERVER_URL + "transactions/create/",
            pendingOffers,
            options
          )
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });

    return promise;
  }

  public mail(emailInfos) {
    let t = this;

    let promise = new Promise(async (resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        t.http
          .put(
            AppSettings.SERVER_URL +
              "transactions/email/" +
              emailInfos["email_id"] +
              "/",
            emailInfos,
            options
          )
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });

    return promise;
  }
  public deleteMail(emailInfos) {
    let t = this;

    let promise = new Promise(async (resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        t.http
          .delete(
            AppSettings.SERVER_URL +
              "transactions/email/" +
              emailInfos["email_id"] +
              "/",
            options
          )
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });

    return promise;
  }
  public getFilters(historyFilters: boolean = false) {
    let t = this;
    let promise = new Promise(async (resolve, reject) => {
      t.storage
        .get(historyFilters ? "history_filters" : "filters")
        .then((filters) => {
          resolve(filters);
        })
        .catch((error) => reject(error));
    });
    return promise;
  }

  public setFilters(filters, historyFilters: boolean = false) {
    return this.storage.set(
      historyFilters ? "history_filters" : "filters",
      filters
    );
  }
}
